import positionViewApi from '../../api/positionview.api.js'
import * as types from '../mutation-types'
import Dialog from '../../plugins/dialog.js'

const state = {
  homeBanner: [],
  cityId: 0
}

const getters = {
  homeBanner: state => state.homeBanner
}

const mutations = {
  [types.SET_HOME_BANNER] (state, {views}) {
    for (let index in views) {
      const view = views[index]
      switch (view.showType) {
        case 1 :
          view.linkUrl = '#/activity/detail/' + view.platformId
          break
        case 2 :
          view.linkUrl = '#/news/detail/' + view.platformId
          break
        case 3 :
          view.linkUrl = '#/goods/detail/' + view.platformId
          break
        case 4 :
          break
        case 5 :
          view.linkUrl = 'javascript:;'
          break
      }
    }
    state.homeBanner = views
  }
}

const actions = {
  /**
   * 获取活动列表
   */
  InitHomeBanner ({state, getters, commit}, {agentNo, cityId, pvAreaId}) {
    let area = 'QinyoutuanHomeBanner'
    if (cityId === state.cityId && state.homeBanner.length > 0) {
      return null
    }
    return positionViewApi.getViews({agentNo, area, cityId, pvAreaId}).then(function (response) {
      if (!response) {
        return
      }
      if (response.data.returnCode === 0) {
        commit(types.SET_HOME_BANNER, {views: response.data.result})
      } else {
        Dialog.toast({title: response.data.message})
      }
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/positionview.js